import type { TextFieldVariants } from "@mui/material";
import { type FieldPath, type FieldValues, type UseControllerProps, useController } from "react-hook-form";
import { type TTextFieldFormExternalProps, TextFieldFormExternal } from "./external";

export type TTextFieldFormProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  Variant extends TextFieldVariants,
  TTransformedValues = TFieldValues,
> = Omit<TTextFieldFormExternalProps<TFieldValues, TName, Variant>, "field" | "fieldState" | "formState"> &
  UseControllerProps<TFieldValues, TName, TTransformedValues>;

export const TextFieldForm = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  Variant extends TextFieldVariants,
  TTransformedValues = TFieldValues,
>({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  ...props
}: TTextFieldFormProps<TFieldValues, TName, Variant, TTransformedValues>) => {
  const { field, fieldState, formState } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
  });

  return <TextFieldFormExternal field={field} fieldState={fieldState} formState={formState} {...props} />;
};
